import { render, staticRenderFns } from "./viewOpportunity.vue?vue&type=template&id=302f567a&scoped=true"
import script from "./viewOpportunity.vue?vue&type=script&lang=js"
export * from "./viewOpportunity.vue?vue&type=script&lang=js"
import style0 from "./viewOpportunity.vue?vue&type=style&index=0&id=302f567a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302f567a",
  null
  
)

export default component.exports